import { Button, Input } from "antd";
import { FC, useState } from "react";
import { doLogin } from "src/store/slices/UserSlice";
import '../css/login.css';
import { useAppDispatch, useAppSelector } from "../hooks";

export const LoginPage: FC = () => {
    const dispatch = useAppDispatch();

    const loading = useAppSelector(state => state.user.loading);
    const error = useAppSelector(state => state.user.error);

    const [login, setLogin] = useState(localStorage.getItem("last_login") ? localStorage.getItem("last_login") : "");
    const [password, setPassword] = useState("");

    const handleLoginButton = () => {
        dispatch(doLogin({ login: login as string, password }));
    }

    return (
        <div className="login-main">
            <div className="login-frame">
                <Input
                    className="login-input login-input-user"
                    placeholder="Логин"
                    value={login as string}
                    onChange={e => { setLogin(e.target.value) }}
                    onPressEnter={handleLoginButton}
                />
                <Input.Password
                    className="login-input"
                    placeholder="Пароль"
                    iconRender={visible => false}
                    value={password}
                    onChange={e => { setPassword(e.target.value) }}
                    onPressEnter={handleLoginButton}
                />
                <span
                    className="login-input login-error"
                    style={{ visibility: error ? 'visible' : 'hidden' }}>
                    {error && error.length > 0 ? error : "aa"}
                </span>
                <Button
                    className="login-btn-login"
                    size="middle"
                    type="primary"
                    loading={loading}
                    onClick={handleLoginButton}>
                    Войти
                </Button>
            </div >
        </div >
    )
}